<template>
  <section>
    <div class="moileParticulars">
      <van-nav-bar title="我的培训班" fixed left-text="返回" left-arrow @click-left="$router.back(-1)">
      </van-nav-bar>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
      >
      <div v-for="goods in list" :key="goods.id" :title="goods.id" > 
        <div style="position: relative;background:  left top no-repeat;background-size: 100% 100%;">
        <img :src="goods.goodsPic"  class="previewImg" />
        </div>
        <div class="particularsTitle cb">
          <h4 class="videoTitle fl">{{goods.goodsName}}</h4>
          <span class="time fr">进度:{{formatPer(goods.studyPercent)}}</span>
        </div>
        <div class="particularsTitle2 cb" style="padding: 0 0.2rem;">
          <h4 class="videoTitle fl">学习时间:{{formatDate(goods.studyStartTime)}} ~ {{formatDate(goods.studyEndTime)}}</h4>
          <span class="time fr" style="color:#222;line-height:0.78rem">学时：{{goods.testHours}}课时</span>
        </div>
        <div class="particularsTitle2 cb">
          <van-button :to="{ path: 'mobileClassDetail', query: {'id':goods.goodsId}}" square color="#1989fa" plain icon="play-circle" type="primary" block size="normal">开始学习</van-button>
          <!-- <van-button square type="primary"  >学习档案</van-button> -->
        </div>
      </div>
      </van-list>
    </van-pull-refresh>
    </div>
  </section>
</template>
<script>
import "@/../static/js/ckplayer/preview_ckplayer.js";
import { debug } from "util";
import { Dialog } from "vant";
import { Toast } from 'vant';
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      page:1,
      pageSize:10,
      list:[]
    };
  },
  methods: {
      //判断是否登录
      judgeLogin(){
          if(this.$sessionStore.getUserId()){
              return true;
          }else{
              return false;
          }

      },
      formatDate: function(dateUnix){
        let dt = new Date(dateUnix);
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate(); 
      return `${y}/${m}/${d}`;
      },
      formatPer: function(per){
        try{
          return parseInt(parseFloat(per) * 100) + "%";
        }catch(e){
          return "0%";
        }
      },
      getSession(){
          this.$axiosPackag.getMessageByAxios("GET", "/session/getSession", null, null, null, resD => {
              if (resD) {
                  this.$sessionStore.initSession(resD);
              }
          });
      },
      onLoad(){
        
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            this.page = 1;
          }
          this.$axiosPackag.getMessageByAxios("GET","/userStudyResource/myStudyData",{pageNumber:this.page,pageSize:this.pageSize,'types':'016005'},null,null, result =>{
            if(result.rows && result.rows.length > 0){
              for (let _r of result.rows) {
                this.list.push(_r);
              }
              this.page += 1;
              if(this.list.length == result.total){
                this.finished = true;
              }
            }else{
              this.finished = true;
            }
            this.loading = false;
          },(errorCall) => {
            this.loading = false;
             this.finished = true;
             
            Toast.fail(errorCall.message);
          });
        
      },
      onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad();
    }
  },
  mounted() {
      setInterval(this.getSession(), 1000 * 300);
      // let id=this.$route.query.id;
      // let params={};
      // params.id=id;
  }
};
</script>

<style scoped>
.moileParticulars{width:100%;height:100%;color:#2c333a;background:#f2f2f2;}
.van-overlay{background:none}
.particularsTab3 .comments{padding:0.3rem;border-radius:0.15rem}
.videoTitle{font-size:0.4rem;width: auto; line-height: 0.78rem;}
.time{font-size:0.293333rem;color:#fff;font-weight:400}
.particularsTitle{
  margin-bottom:auto;
  padding: 0.1rem 0.2rem 0.1rem 0.2rem;
  position: relative;
  top: -0.98rem;
  background-color: rgba(0,0,0,0.7);
  color: #fff;
  overflow:hidden}
  .previewImg{
    width: 100%;
    max-height: 5.5rem;
    min-height: 5.5rem;
  }
  .particularsTitle2{
     position: relative;
     top: -0.98rem;
  }
</style>



// WEBPACK FOOTER //
// MobileClassList.vue?34089273